<template>
	<div class="pl-4 CustomerPickerButton is-flex is-justify-content-space-between is-align-items-center" @click="setCustomerPicker(!getCustomerPicker)">
		<div>
			{{ getActiveCustomer?.name ? $utils.format.truncateString(getActiveCustomer.name, 30) : $t('customer.select_prompt') }}
		</div>
		<div class="is-flex is-align-items-center is-justify-content-center" style="height: 100%; width: 48px">
			<span class="icon is-info"><i :class="getCustomerPicker ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/></span>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters('appStore', ['getCustomerPicker']),
		...mapGetters('user', ['getActiveCustomer'])
	},

	methods: {
		...mapActions('appStore', ['setCustomerPicker'])
	}
};
</script>


<style lang="scss">
.CustomerPickerButton {
	text-align: left;
	cursor: pointer;
	border: 0;
	width: 300px;
	color: #ef7c21;
	background-color: #363a41;

	position: relative;
	transition: background-color 0.3s ease;

	&:hover {
		transition: background-color 0.3s ease;
		background-color: #4b5158;
	}
}
</style>
